<template>
  <div class="pts-tile">
    <i class="material-icons">{{ icon }}</i><br />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tile',
  props: {
    icon: String
  }
}
</script>

<style scoped>
.pts-tile {
  width: 180px;
  height: 180px;
  background: #FFFFFF;
  margin: 20px;
  border-radius: 10px;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, .12);
}

.pts-tile i {
  font-size: 80px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tile.vue